const isPassword = new RegExp(/^(?=.*[@!#$/\\])[@!#$&*()/\\a-zA-Z0-9]{6,30}$/);
const isText = new RegExp(/[a-zA-Z]$/);
const isNumber = new RegExp(/^([0-9])+$/);
const isNumberNoZero = new RegExp(/^([1-9])+$/);
const isTextAndComma = new RegExp(/[,a-zA-Z]$/);
const isTextAndSpace = new RegExp(/[,a-zA-Z\ ]$/);
const isNumberAndComma = new RegExp(/[,0-9]$/);
const isTextAndNumbersAndTripleChar = new RegExp(/^([A-Z\+a-z\+0-9\+_,\-.])+$/);
const isTextAndNumbersAndQuadChar = new RegExp(/^([A-Z\+a-z\+0-9\+_,\-.])+$/);
const isIP = new RegExp(/^[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}$/);

const checkIfSrIsCorrect = (mask) => {
  const numMask = Number(mask);
  let result = false;
  switch (numMask) {
    case 255:
      result = true;
      break;

    case 252:
      result = true;
      break;

    case 248:
      result = true;
      break;
  
    case 240:
      result = true;
      break;

    case 224:
      result = true;
      break;

    case 192:
      result = true;
      break;
    
    case 128:
      result = true;
      break;
  
    case 0:
      result = true;
      break;

    default:
      break;
  }

  return result;
};

const verfyIpAndMask = (item) => {

}

const valuesAnalyze = {
  checkPassword: (pass) => {
    return isPassword.test(pass);
  },
  checkText: (txt) => {
    return isText.test(txt);
  },
  checkNumber: (num) => {
    return isNumber.test(num);
  },
  isNumberNoZero: (num) => {
    return isNumberNoZero.test(num);
  },
  checkTextAndComma: (char) => {
    return isTextAndComma.test(char);
  },
  isNumberAndComma: (char) => {
    return isNumberAndComma.test(char);
  },
  isTextAndSpace: (char) => {
    return isTextAndSpace.test(char);
  },
  isTripleChar: (char) => {
    return isTextAndNumbersAndTripleChar.test(char);
  },
  isQuadChar: (char) => {
    return isTextAndNumbersAndQuadChar.test(char);
  },
  isIP: (ip) => {
    const result = ip.split('.').map((octate) => {
      return Number(octate) >= 0 && Number(octate) <= 255 ? true : false
    });
    return result.includes(false) ? false : isIP.test(ip);
  },
  isMask: (mask) => {
    if (typeof mask !== 'string') return false;
    const trimmed = mask.trim();
    if (trimmed === '' || !trimmed.includes('.')) return false;
    const octets = trimmed.split('.');
    if (octets.length !== 4) return false;
    let zeros = false;
    for (const oct of octets) {
      const n = Number(oct);
      if (!Number.isInteger(n) || n < 0 || n > 255) return false;
      for (let i = 7; i >= 0; i -= 1) {
        const bit = (n >> i) & 1;
        if (bit === 1) {
          if (zeros) return false;
        } else {
          zeros = true;
        }
      }
    }
    return true;
  },
};

export default valuesAnalyze;
